import { sumOf } from '../../shared/utils/arrayUtils.ts';
import { RecordDraft } from '../types/sharedTypeImpl.ts';


export function countRecordValuesFilled(record: RecordDraft): number {
    const numValuesFilled = sumOf(record.parts, part => {
        const positionValuesFilled = sumOf(part.positionValues, positionValue => {
            const valueFilled = positionValue.value != null && positionValue.value !== '';
            return valueFilled ? 1 : 0;
        });
        return positionValuesFilled;
    });
    return numValuesFilled;
}
